import { ReactComponent as PersonIcon } from 'images/newIcons/person.svg';
import { ReactComponent as GroupIcon } from 'images/newIcons/personGroup.svg';

import { GroupNode } from './AccessSidebar';

export const renderNodeIcon = (node: GroupNode) => (
  <>
    {node.data.isFolder ? (
      <GroupIcon className="w-full h-full" />
    ) : (
      <PersonIcon className="w-full h-full" />
    )}
  </>
);
